import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';   
const EvaluationScholarships = () => {  
  useEffect(() => {
    document.title = 'Evaluation & Scholarships - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>Prospectus</li>
                    <li>Evaluation & Scholarships</li>
                </ul>
            </div> 
            <section className="innerbody">
            <div className="container"> 
                    <div className="row">
                    <div className="col-lg-12">
                       
                    <h3>Procedure For Promotion</h3>
                    <p>Evaluation will be based on student's continuous academic performance during the year
                        There will be no formal tests or examination for Nursery and KG classes. Promotion to next class will be
                        granted on the basis of the child's performance in all fields during the year.</p>
                    <p>Class 1st to 10th onwards will have two independent terms. However, some important topics may be included
                        in the second term examination. Weightage of class tests, Unit Test and term examinations will be
                        considered for promotion.</p>
                    <h3>Scholarships</h3>
                    <p>Scholarships are awarded to deserving students in Academics which motivate students to strive for
                        excellence and to maximize their potential.</p>
                    </div>
                    </div> 
                </div>
           </section>
           <Footer/>
        </>
    );
}

export default EvaluationScholarships;
